import { apiSlice } from '@/store/api/apiSlice';

export type Gender = 'Male' | 'Female';

export interface BirthDetailsPayload {
  userId: string;
}

export interface AstroData {
  id: string;
  ascendant: string;
  ascendantLord: string;
  sign: string;
  signLord: string;
  nakshatra: string;
  nakshatraLord: string;
  charan: number;
  tatva: string;
  varna: string;
  vashya: string;
  yoni: string;
  gan: string;
  nadi: string;
  yog: string;
  karan: string;
  tithi: string;
  yunja: string;
  nameAlphabet: string;
  paya: string;
  birthDetailId: string;
}

export interface Planet {
  id: string;
  name: string;
  sign: string;
  degree: number;
  signLord: string;
  nakshatra: string;
  nakshatraPada: number;
  nakshatraLord: string;
  planetAwastha: string;
  house: number;
  isRetro: boolean;
  isPlanetSet: boolean;
  birthDetailId: string;
}

export interface DivisionalChartItem {
  id: string;
  sign: string;
  planets: string[];
  nakshatra: string[];
  house: number;
  degree: number[];
  birthDetailId: string;
}

export interface User {
  id: string;
  fullName: string;
  username: string;
  email: string;
  city: string;
  state: string;
  country: string;
  status: string;
  userType: string;
}

export interface BirthDetails {
  id: string;
  date: string;
  time: string;
  place: string;
  latitude: number;
  longitude: number;
  sunrise: string;
  sunset: string;
  ayanamsha: number;
  fullName: string;
  userId: string;
  createdAt: string;
  updatedAt: string;

  astroData: AstroData;
  planets: Planet[];
  navamsa: DivisionalChartItem[];
  dasamsa: DivisionalChartItem[];

  user: User;
  altAscendant?: string;
  altAscendantLord?: string;
  altSign?: string;
  altSignLord?: string;
  altNakshatra?: string;
  altNakshatraLord?: string;
}

export interface BirthDetailsResponse {
  userId: string;
  birthDetails: BirthDetails;

  planets?: Planet[];
  navamsa?: DivisionalChartItem[];
  dasamsa?: DivisionalChartItem[];

  dateOfBirth: string;
  timeOfBirth: string;
  placeOfBirth: string;
  timezone: string;
  sunrise: string;
  sunset: string;
  ayanamsha: string;
  rashi: string;

  personality: {
    overview: string;
    ascendant: {
      sign: string;
      lord: string;
      traits: string[];
    };
    sunSign: {
      sign: string;
      lord: string;
      tatva: string;
      traits: string[];
    };
    nakshatra: {
      name: string;
      lord: string;
      charan: string;
    };
    otherFactors: Record<string, string>;
  };

  geoLocation: Record<string, unknown>;
  generatedAt: string;
}

export const birthDetailsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getBirthDetails: builder.query<BirthDetailsResponse, { userId: string }>({
      query: ({ userId }) => ({
        url: '/astrology/birth-details',
        method: 'GET',
        params: { userId },
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetBirthDetailsQuery } = birthDetailsApi;
